export default __webpack_public_path__ + "media/zurb/img/work/tcl/tcl-drive-70a0941142800e80c70ad6ec0786d302.gif";